export function readFrameChoices(select) {
  return Array.from(select.options).map(option => ({
    id: option.value,
    material: option.dataset.material || '',
    finish: option.dataset.finish || '',
    finishLabel: option.dataset.finishLabel || option.dataset.finish || '',
    price: option.dataset.price || '',
    available: !option.disabled && option.dataset.available !== 'false'
  }));
}

export function chooseFrameMaterial(choices, material, rememberedId) {
  const matches = choices.filter(choice => choice.material === material);
  return matches.find(choice => choice.id === rememberedId && choice.available)
    || matches.find(choice => choice.available)
    || matches[0];
}

if (typeof customElements !== 'undefined' && !customElements.get('oyster-frame-picker')) {
  customElements.define('oyster-frame-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.select = this.querySelector('select');
      if (!this.select) return;
      this.choices = readFrameChoices(this.select);
      if (!this.choices.length || this.choices.some(choice => !choice.material || !choice.finish)) return;
      this.initialized = true;
      this.remembered = new Map();
      this.materialInputs = new Map();
      this.finishInputs = new Map();
      const materials = [...new Set(this.choices.map(choice => choice.material))];
      for (const [index, material] of materials.entries()) {
        const input = this.addChoice(this.querySelector('[data-material-options]'), 'material', String(index), this.materialLabel(material), this.choices.find(choice => choice.material === material).price);
        input.value = material;
        input.disabled = !this.choices.some(choice => choice.material === material && choice.available);
        input.addEventListener('change', () => {
          const choice = chooseFrameMaterial(this.choices, material, this.remembered.get(material));
          if (choice) this.choose(choice.id);
        });
        this.materialInputs.set(material, input);
      }
      for (const choice of this.choices) {
        const input = this.addChoice(this.querySelector('[data-finish-options]'), 'finish', choice.id, choice.finishLabel, choice.available ? '' : this.dataset.unavailableLabel);
        input.value = choice.id;
        input.addEventListener('change', () => this.choose(choice.id));
        this.finishInputs.set(choice.id, input);
      }
      this.select.addEventListener('change', () => this.sync());
      this.select.addEventListener('oyster:selection-sync', () => this.sync());
      this.querySelector('[data-frame-fallback]').hidden = true;
      this.querySelector('[data-frame-controls]').hidden = false;
      this.sync();
    }

    materialLabel(material) {
      if (material === 'Wood') return this.dataset.woodLabel;
      if (material === 'Anodized aluminum') return this.dataset.aluminumLabel;
      return material;
    }

    addChoice(container, kind, key, title, subtitle) {
      const wrapper = document.createElement('div');
      wrapper.className = 'oy-frame-picker__choice';
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = `${this.select.id}-${kind}`;
      input.id = `${this.select.id}-${kind}-${key}`;
      const label = document.createElement('label');
      label.htmlFor = input.id;
      const text = document.createElement(kind === 'material' ? 'strong' : 'span');
      text.textContent = title;
      label.append(text);
      if (subtitle) {
        const note = document.createElement('small');
        note.textContent = subtitle;
        label.append(note);
      }
      wrapper.append(input, label);
      container.append(wrapper);
      return input;
    }

    choose(id) {
      const choice = this.choices.find(item => item.id === id);
      if (!choice?.available) return;
      this.select.value = id;
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    sync() {
      const selected = this.choices.find(choice => choice.id === this.select.value);
      if (!selected) return;
      this.remembered.set(selected.material, selected.id);
      this.materialInputs.forEach((input, material) => { input.checked = material === selected.material; });
      this.choices.forEach(choice => {
        const input = this.finishInputs.get(choice.id);
        input.parentElement.hidden = choice.material !== selected.material;
        input.disabled = choice.material !== selected.material || !choice.available;
        input.checked = choice.id === selected.id;
      });
      this.querySelector('[data-finish-heading]').textContent = selected.material === 'Wood' ? this.dataset.woodFinishLabel : this.dataset.metalFinishLabel;
      this.querySelector('[data-frame-summary]').textContent = `${this.materialLabel(selected.material)} · ${selected.finishLabel}`;
    }
  });
}
